import * as React from 'react'
import {Route} from 'react-router-dom'
import {AdminRouter} from './admin/AdminRouter'
import {UserRouter} from './users/UsersRouter'
import About from './common/About'
import Restricted from './common/Restricted'
import {Error404} from './common/Error404'
import {PrivateRoute, PrivateRouteOutlet} from '../components/PrivateRoute'
import {AccountPage} from './users/Account/AccountPage'
import {ConfirmSignup} from './common/Auth/ConfirmSignup'
import {Eroles} from '../types'
import {Getup} from './users/Getup'
import {CustomRoutes} from './CustomRoutes'
import {ResetPassword} from './common/Auth/ResetPassword'
import ErrorFallback from '../components/ErrorFallback'
//Lazy
const Login = React.lazy(() => import('./common/Auth/Login'))
const Register = React.lazy(() => import('./common/Auth/Register'))
const RegisterForAdmin = React.lazy(
  () => import('./common/Auth/RegisterForAdmin'),
)
const RegisterOwner = React.lazy(() => import('./common/Auth/RegisterOwner'))
export const RouterPages: React.FunctionComponent<{}> = () => {
  return (
    // <BrowserRouter>
    <CustomRoutes>
      <Route path="/" element={<Login />}></Route>
      <Route path="/login" element={<Login />}></Route>
      {/* <Route path="/getup" element={<Getup />} /> */}
      <Route path="/register" element={<Register />}></Route>
      <Route path="/register-for-admin" element={<RegisterForAdmin />}></Route>
      <Route path="/register-school" element={<RegisterOwner />}></Route>
      <Route path="/reset-password" element={<ResetPassword />}></Route>
      <Route path="/confirm-signup" element={<ConfirmSignup />}></Route>
      <Route path="/about" element={<About />}></Route>
      <Route path="/pricing" element={<div>prices</div>}></Route>
      <Route path="/restricted" element={<Restricted />}></Route>

      <Route
        path="/account"
        element={
          <PrivateRoute
            roles={[Eroles.STUDIENT, Eroles.SCHOOLOWNER, Eroles.ADMIN]}
          >
            <AccountPage />
          </PrivateRoute>
        }
      />
      <Route
        path="school/*"
        element={
          <PrivateRoute
            roles={[Eroles.STUDIENT, Eroles.SCHOOLOWNER, Eroles.ADMIN]}
          >
            <UserRouter />
          </PrivateRoute>
        }
      />

      <Route
        path="school-admin/*"
        element={
          <PrivateRoute roles={[Eroles.SCHOOLOWNER, Eroles.ADMIN]}>
            <AdminRouter />
          </PrivateRoute>
        }
      />

      <Route
        path="/outlet-test/*"
        element={
          <PrivateRouteOutlet
            roles={[Eroles.STUDIENT, Eroles.SCHOOLOWNER, Eroles.ADMIN]}
          />
        }
      >
        <Route path="admin" element={<AdminRouter />} />
      </Route>
      <Route
        path="/500"
        element={
          <ErrorFallback
            error={
              new Error(
                'Ceci est une error Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
              )
            }
            resetErrorBoundary={undefined}
          ></ErrorFallback>
        }
      ></Route>
      <Route path="*" element={<Error404 />}></Route>
    </CustomRoutes>
    // </BrowserRouter>
  )
}
